export default class ServiceCarousel {
    static init(): void {
        this.handleCarousel();
    }

    static handleCarousel(): void {
        const carousel = document.querySelector('.service-carousel') as HTMLElement | null;
        const items = carousel?.querySelectorAll('.service-carousel__item');
        const next = carousel?.querySelector('.service-carousel__arrow--right img');
        const prev = carousel?.querySelector('.service-carousel__arrow--left img');

        if (carousel && items && prev && next) {
            const firstItem = items.item(0);
            if (firstItem?.classList.contains('service-carousel__item--empty')) {
                items.item(1).classList.add('service-carousel__item--active');
                setTimeout(() => {
                    this.handleNext(items);
                }, 100);
            } else {
                items.item(0).classList.add('service-carousel__item--active');
                prev?.classList.add('service-carousel__arrow--hidden');
            }

            setTimeout(() => {
                if (carousel.classList.contains('service-carousel--hidden')) {
                    carousel.classList.remove('service-carousel--hidden');
                }
            }, 200);


            prev.addEventListener('click', () => {
                const next = document.querySelector('.service-carousel__arrow--right img');
                const prev = document.querySelector('.service-carousel__arrow--left img');
                if (prev?.classList.contains('service-carousel__arrow--hidden')) return;

                next?.classList.remove('service-carousel__arrow--hidden');
                prev?.classList.add('service-carousel__arrow--hidden');
                this.handlePrev(items);
            });

            next.addEventListener('click', () => {
                const next = document.querySelector('.service-carousel__arrow--right img');
                const prev = document.querySelector('.service-carousel__arrow--left img');
                if (next?.classList.contains('service-carousel__arrow--hidden')) return;

                prev?.classList.remove('service-carousel__arrow--hidden');
                next?.classList.add('service-carousel__arrow--hidden');
                this.handleNext(items);
            });

            if (items.length === 1) {
                next.classList.add('d-none');
                prev.classList.add('d-none');
            }
        }
    }

    static handleNext(items: NodeListOf<Element>): void {
        const activeItem = document.querySelector('.service-carousel__item--active');
        activeItem?.classList.remove('service-carousel__item--active');
        const nextItem = activeItem?.nextElementSibling;

        if (!nextItem) return;
        nextItem.classList.add('service-carousel__item--active');

        const carousel = document.querySelector('.service-carousel__items');
        const itemWidth = items[0].clientWidth;
        carousel?.scrollBy({
            top: 0,
            left: itemWidth,
            behavior: 'smooth'
        });

        setTimeout(() => {
            const nextArrow = document.querySelector('.service-carousel__arrow--right img');
            const nextNextItem = nextItem.nextElementSibling;
            if (nextNextItem?.classList.contains('service-carousel__item--empty') || nextNextItem === null) {
                nextArrow?.classList.add('service-carousel__arrow--hidden');
            } else {
                nextArrow?.classList.remove('service-carousel__arrow--hidden');
            }
        }, 500);
    }

    static handlePrev(items: NodeListOf<Element>): void {
        const activeItem = document.querySelector('.service-carousel__item--active');
        activeItem?.classList.remove('service-carousel__item--active');
        const prevItem = activeItem?.previousElementSibling;

        if (!prevItem) return;
        prevItem.classList.add('service-carousel__item--active');

        const carousel = document.querySelector('.service-carousel__items');
        const itemWidth = items[0].clientWidth;

        carousel?.scrollBy({
            top: 0,
            left: -itemWidth,
            behavior: 'smooth',
        });

        setTimeout(() => {
            const prevArrow = document.querySelector('.service-carousel__arrow--left img');
            const prevPrevItem = prevItem.previousElementSibling;
            if (prevPrevItem?.classList.contains('service-carousel__item--empty') || prevPrevItem === null) {
                prevArrow?.classList.add('service-carousel__arrow--hidden');
            } else {
                prevArrow?.classList.remove('service-carousel__arrow--hidden');
            }
        }, 500);
    }
}
